import { ContentViewType } from "../global";

export function isDesktop(contentViewType: ContentViewType): boolean {
  return contentViewType === ContentViewType.Desktop;
}

export function isMobile(contentViewType: ContentViewType): boolean {
  return contentViewType === ContentViewType.Mobile;
}
